/*----------------------------------
- PUBLIC TABLE IDENTITY HELPERS
----------------------------------*/

/**
 * @docs docs/features/product-domain-listings
 *
 * The deterministic glyph and the name split, shared by the table's identity cell.
 * Both moved here from the retired card so the table keeps the visual identity visitors already
 * recognise from the previous listing.
 */

import type { SpriteIconName } from '@/client/components/ui/icon/Icon';

/* Sprite names rather than lucide components: the website draws every icon from one cached sprite.
   The order is load-bearing, `pickCardVisual` indexes into it and `FILLED_ICON_INDEXES` below
   points at positions in this exact list. */
export const CARD_ICONS: readonly SpriteIconName[] = [
    'anchor',
    'globe-2',
    'cloud',
    'sigma',
    'waves',
    'droplet',
    'flame',
    'grid-2x2',
    'medal',
    'hammer',
    'target',
    'triangle',
];

/** Icons whose lucide shape reads better filled than stroked at this size. */
export const FILLED_ICON_INDEXES = [2, 5, 6, 11];

/**
 * Name and suffix, split at the registrable boundary.
 *
 * Split at the last dot rather than the first: `co.uk` is one suffix, and splitting at the first
 * dot would print the name as `example` with a `.co.uk` that is not what the row carries.
 */
export const splitDomainLabel = (value: string): { name: string; tld: string } => {
    const separatorIndex = value.lastIndexOf('.');
    if (separatorIndex <= 0 || separatorIndex === value.length - 1) return { name: value, tld: '' };
    return { name: value.slice(0, separatorIndex), tld: value.slice(separatorIndex) };
};
